export default "__VITE_ASSET__8f12d8a8__"